import http from '@/api/client'
import i18n from '@/i18n'
import { siteSettings, type SiteSettings } from './siteSettingsState'
export { siteSettings, type SiteSettings } from './siteSettingsState'

let pending:Promise<void>|undefined
let loaded=false
export function applySiteSettings(value:SiteSettings) {
  Object.assign(siteSettings,value)
  document.title=value.site_name
  if (!localStorage.getItem('dcim.locale.preference')) {
    i18n.global.locale.value=value.language as 'zh-CN'|'en-US'
    document.documentElement.lang=value.language
  }
}
export function loadSiteSettings(force=false) {
  if(pending)return pending
  if(loaded&&!force)return Promise.resolve()
  pending=http.get('/site-settings').then(({data})=>{applySiteSettings(data.data);loaded=true}).finally(()=>{pending=undefined})
  return pending
}
export function setPreferredLanguage(value:string) {
  if(value==='system')localStorage.removeItem('dcim.locale.preference')
  else localStorage.setItem('dcim.locale.preference',value)
  const language=value==='system'?siteSettings.language:value
  i18n.global.locale.value=language as 'zh-CN'|'en-US'
  document.documentElement.lang=language
}
